module.exports = __webpack_public_path__ + "static/media/vedio-scanning.0fd9b51d.png";